import { __rest } from "tslib";
import { buildGridRowsAndTiers } from "./buildGridRowsAndTiers";
import createBayGrid from "./createBayGrid";
/**
 * Creates a grid (above & below decks) from parameters.
 * Each part omits the centerline row (00) when its own flag (`aboveCenterLineRow` / `belowCenterLineRow`) is off.
 * @returns ISvgWithSize { svg, width, height }
 */
export function createGridFromConfig(_a) {
    var { minAboveTier, maxAboveTier, minBelowTier, maxBelowTier, centerLineRow, aboveCenterLineRow, belowCenterLineRow, maxRow } = _a, gridOptions = __rest(_a, ["minAboveTier", "maxAboveTier", "minBelowTier", "maxBelowTier", "centerLineRow", "aboveCenterLineRow", "belowCenterLineRow", "maxRow"]);
    const minRow = centerLineRow ? 0 : 1;
    if (Number(maxRow) < minRow) {
        throw { message: `tedivoGridFromConfig: maxRow must be >= ${minRow}` };
    }
    const { aboveRowsArray, belowRowsArray, aboveTiersArray, belowTiersArray } = buildGridRowsAndTiers({
        minAboveTier,
        maxAboveTier,
        minBelowTier,
        maxBelowTier,
        centerLineRow,
        aboveCenterLineRow,
        belowCenterLineRow,
        maxRow,
    });
    if (aboveTiersArray === undefined && belowTiersArray === undefined) {
        throw { message: `tedivoGridFromConfig: no tiers to draw` };
    }
    return createBayGrid(Object.assign(Object.assign({}, gridOptions), { aboveTiersArray: aboveTiersArray || [], belowTiersArray: belowTiersArray || [], rowsArray: aboveTiersArray ? aboveRowsArray : belowRowsArray, aboveRowsArray,
        belowRowsArray }));
}
